import { ActionType, ClickResult, FormFieldWidget, ModelFieldType, ReloadViewActionWidget, SPI, ViewType } from '@kunlun/dependencies';
import { DetailBaseCustomTableWidget } from '../DetailBaseCustomTableWidget';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Detail,
    ttype: ModelFieldType.ManyToMany,
    widget: 'Table',
    name: 'createOrderSaleSkuList',
    model: [
      'deli.aries.seller.SellerDistributionCreateOrderParam',
      'deli.aries.seller.SellerDistributorAuditOrderParam'
    ],
    multi: true
  })
)
export class DetailM2mMultiTradeOrderItemDetailFieldWidget extends DetailBaseCustomTableWidget {
  public initialize(props: any): this {
    super.initialize(props);
    return this;
  }
}
